var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "vx-card",
        { staticClass: "mb-4" },
        [
          _c("h4", { staticClass: "mb-1" }, [
            _vm._v(_vm._s(_vm.$t("campaign.section_basic"))),
          ]),
          _c("div", { staticClass: "vx-row" }, [
            _c(
              "div",
              { staticClass: "vx-col sm:w-5/12 w-full" },
              [
                _c(
                  "b-form-group",
                  {
                    attrs: {
                      label: _vm.$t("campaign.name"),
                      "label-for": "name",
                    },
                  },
                  [
                    _c("b-form-input", {
                      staticClass: "required",
                      attrs: { id: "name", type: "text" },
                      model: {
                        value: _vm.model.name,
                        callback: function ($$v) {
                          _vm.$set(_vm.model, "name", $$v)
                        },
                        expression: "model.name",
                      },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "vx-col sm:w-3/12 w-full" },
              [
                _c(
                  "b-form-group",
                  {
                    attrs: {
                      label: _vm.$t("campaign.legal_entity"),
                      "label-for": "legal_entity_id",
                    },
                  },
                  [
                    _c("v-select", {
                      staticClass: "w-full required-select",
                      attrs: {
                        id: "legal_entity_id",
                        options: _vm.legalEntities,
                        reduce: function (opt) {
                          return opt.id
                        },
                        label: "name",
                      },
                      model: {
                        value: _vm.model.legal_entity_id,
                        callback: function ($$v) {
                          _vm.$set(_vm.model, "legal_entity_id", $$v)
                        },
                        expression: "model.legal_entity_id",
                      },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "vx-col sm:w-2/12 w-full" },
              [
                _c(
                  "b-form-group",
                  {
                    attrs: {
                      label: _vm.$t("campaign.starts_at"),
                      "label-for": "starts_at",
                    },
                  },
                  [
                    _c("b-form-input", {
                      attrs: { id: "starts_at", type: "date" },
                      model: {
                        value: _vm.model.starts_at,
                        callback: function ($$v) {
                          _vm.$set(_vm.model, "starts_at", $$v)
                        },
                        expression: "model.starts_at",
                      },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "vx-col sm:w-2/12 w-full" },
              [
                _c(
                  "b-form-group",
                  {
                    attrs: {
                      label: _vm.$t("campaign.ends_at"),
                      "label-for": "ends_at",
                    },
                  },
                  [
                    _c("b-form-input", {
                      attrs: { id: "ends_at", type: "date" },
                      model: {
                        value: _vm.model.ends_at,
                        callback: function ($$v) {
                          _vm.$set(_vm.model, "ends_at", $$v)
                        },
                        expression: "model.ends_at",
                      },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
          ]),
          _c(
            "b-form-group",
            {
              attrs: {
                label: _vm.$t("campaign.objective"),
                "label-for": "objective",
              },
            },
            [
              _c("b-form-input", {
                attrs: { id: "objective", type: "text" },
                model: {
                  value: _vm.model.objective,
                  callback: function ($$v) {
                    _vm.$set(_vm.model, "objective", $$v)
                  },
                  expression: "model.objective",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "vx-card",
        { staticClass: "mb-4" },
        [
          _c("h4", { staticClass: "mb-1" }, [
            _vm._v(_vm._s(_vm.$t("campaign.section_products"))),
          ]),
          _c("small", { staticClass: "text-muted d-block mb-2" }, [
            _vm._v(_vm._s(_vm.$t("campaign.section_products_hint"))),
          ]),
          _c(
            "v-select",
            {
              staticClass: "w-full",
              attrs: {
                options: _vm.products,
                reduce: function (opt) {
                  return opt.id
                },
                label: "name",
                multiple: "",
              },
              model: {
                value: _vm.model.product_ids,
                callback: function ($$v) {
                  _vm.$set(_vm.model, "product_ids", $$v)
                },
                expression: "model.product_ids",
              },
            },
            [
              _c("div", { attrs: { slot: "no-options" }, slot: "no-options" }, [
                _vm._v(_vm._s(_vm.$t("campaign.no_products"))),
              ]),
            ]
          ),
        ],
        1
      ),
      _c("vx-card", { staticClass: "mb-4" }, [
        _c("h4", { staticClass: "mb-1" }, [
          _vm._v(_vm._s(_vm.$t("campaign.section_money"))),
        ]),
        _c("div", { staticClass: "vx-row" }, [
          _c(
            "div",
            { staticClass: "vx-col sm:w-3/12 w-full" },
            [
              _c(
                "b-form-group",
                { attrs: { label: _vm.$t("campaign.discount_type") } },
                [
                  _c("b-form-radio-group", {
                    attrs: { options: _vm.typeList },
                    model: {
                      value: _vm.model.discount_type,
                      callback: function ($$v) {
                        _vm.$set(_vm.model, "discount_type", $$v)
                      },
                      expression: "model.discount_type",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "vx-col sm:w-3/12 w-full" },
            [
              _c(
                "b-form-group",
                { attrs: { label: _vm.$t("campaign.discount") } },
                [
                  _c(
                    "b-input-group",
                    {
                      attrs: {
                        prepend: _vm.model.discount_type === "VA" ? "R$" : "%",
                      },
                    },
                    [
                      _c("b-form-input", {
                        attrs: { type: "number", step: "0.01", min: "0" },
                        model: {
                          value: _vm.model.discount_amount,
                          callback: function ($$v) {
                            _vm.$set(_vm.model, "discount_amount", $$v)
                          },
                          expression: "model.discount_amount",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "vx-col sm:w-3/12 w-full" },
            [
              _c(
                "b-form-group",
                { attrs: { label: _vm.$t("campaign.commission_type") } },
                [
                  _c("b-form-radio-group", {
                    attrs: { options: _vm.typeList },
                    model: {
                      value: _vm.model.commission_type,
                      callback: function ($$v) {
                        _vm.$set(_vm.model, "commission_type", $$v)
                      },
                      expression: "model.commission_type",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "vx-col sm:w-3/12 w-full" },
            [
              _c(
                "b-form-group",
                { attrs: { label: _vm.$t("campaign.commission") } },
                [
                  _c(
                    "b-input-group",
                    {
                      attrs: {
                        prepend:
                          _vm.model.commission_type === "VA" ? "R$" : "%",
                      },
                    },
                    [
                      _c("b-form-input", {
                        attrs: { type: "number", step: "0.01", min: "0" },
                        model: {
                          value: _vm.model.commission_amount,
                          callback: function ($$v) {
                            _vm.$set(_vm.model, "commission_amount", $$v)
                          },
                          expression: "model.commission_amount",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ]),
        _c("div", { staticClass: "vx-row" }, [
          _c(
            "div",
            { staticClass: "vx-col sm:w-4/12 w-full" },
            [
              _c(
                "b-form-group",
                { attrs: { label: _vm.$t("campaign.commission_base") } },
                [
                  _c("b-form-radio-group", {
                    attrs: { options: _vm.baseList },
                    model: {
                      value: _vm.model.commission_base,
                      callback: function ($$v) {
                        _vm.$set(_vm.model, "commission_base", $$v)
                      },
                      expression: "model.commission_base",
                    },
                  }),
                  _c("small", { staticClass: "text-muted" }, [
                    _vm._v(_vm._s(_vm.$t("campaign.commission_base_hint"))),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "vx-col sm:w-4/12 w-full" },
            [
              _c(
                "b-form-group",
                { attrs: { label: _vm.$t("campaign.cost_bearer") } },
                [
                  _c("b-form-select", {
                    attrs: { options: _vm.bearerList },
                    model: {
                      value: _vm.model.cost_bearer,
                      callback: function ($$v) {
                        _vm.$set(_vm.model, "cost_bearer", $$v)
                      },
                      expression: "model.cost_bearer",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "vx-col sm:w-4/12 w-full" },
            [
              _c(
                "b-form-group",
                { attrs: { label: _vm.$t("campaign.budget_cap") } },
                [
                  _c(
                    "b-input-group",
                    { attrs: { prepend: "R$" } },
                    [
                      _c("b-form-input", {
                        attrs: { type: "number", step: "0.01", min: "0" },
                        model: {
                          value: _vm.model.budget_cap,
                          callback: function ($$v) {
                            _vm.$set(_vm.model, "budget_cap", $$v)
                          },
                          expression: "model.budget_cap",
                        },
                      }),
                    ],
                    1
                  ),
                  _c("small", { staticClass: "text-muted" }, [
                    _vm._v(_vm._s(_vm.$t("campaign.budget_cap_hint"))),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
        ]),
        _c(
          "div",
          { staticClass: "simulator" },
          [
            _c(
              "div",
              { staticClass: "flex items-center justify-between mb-1" },
              [
                _c("h5", { staticClass: "mb-0" }, [
                  _vm._v(_vm._s(_vm.$t("campaign.simulator"))),
                ]),
                _c(
                  "div",
                  { staticClass: "flex items-center gap-1" },
                  [
                    _c("small", { staticClass: "text-muted" }, [
                      _vm._v(_vm._s(_vm.$t("campaign.simulator_price"))),
                    ]),
                    _c("b-form-input", {
                      staticStyle: { width: "110px" },
                      attrs: {
                        type: "number",
                        step: "0.01",
                        min: "0",
                        size: "sm",
                      },
                      model: {
                        value: _vm.simPrice,
                        callback: function ($$v) {
                          _vm.simPrice = $$v
                        },
                        expression: "simPrice",
                      },
                    }),
                    _c("small", { staticClass: "text-muted ml-1" }, [
                      _vm._v(_vm._s(_vm.$t("campaign.simulator_fee"))),
                    ]),
                    _c("b-form-input", {
                      staticStyle: { width: "80px" },
                      attrs: {
                        type: "number",
                        step: "0.1",
                        min: "0",
                        max: "100",
                        size: "sm",
                      },
                      model: {
                        value: _vm.simFeePct,
                        callback: function ($$v) {
                          _vm.simFeePct = $$v
                        },
                        expression: "simFeePct",
                      },
                    }),
                  ],
                  1
                ),
              ]
            ),
            _c("small", { staticClass: "text-muted d-block mb-2" }, [
              _vm._v(_vm._s(_vm.$t("campaign.simulator_hint"))),
            ]),
            _c("table", { staticClass: "sim-table" }, [
              _c("tbody", [
                _c("tr", [
                  _c("td", [_vm._v(_vm._s(_vm.$t("campaign.sim_gross")))]),
                  _c("td", { staticClass: "text-right" }, [
                    _vm._v(_vm._s(_vm.money(_vm.sim.gross))),
                  ]),
                ]),
                _c("tr", { staticClass: "text-danger" }, [
                  _c("td", [_vm._v(_vm._s(_vm.$t("campaign.sim_discount")))]),
                  _c("td", { staticClass: "text-right" }, [
                    _vm._v("- " + _vm._s(_vm.money(_vm.sim.discount))),
                  ]),
                ]),
                _c("tr", [
                  _c("td", { staticClass: "font-medium" }, [
                    _vm._v(_vm._s(_vm.$t("campaign.sim_charged"))),
                  ]),
                  _c("td", { staticClass: "text-right font-medium" }, [
                    _vm._v(_vm._s(_vm.money(_vm.sim.charged))),
                  ]),
                ]),
                _c("tr", { staticClass: "text-danger" }, [
                  _c("td", [_vm._v(_vm._s(_vm.$t("campaign.sim_commission")))]),
                  _c("td", { staticClass: "text-right" }, [
                    _vm._v("- " + _vm._s(_vm.money(_vm.sim.commission))),
                  ]),
                ]),
                _c("tr", { staticClass: "text-danger" }, [
                  _c("td", [_vm._v(_vm._s(_vm.$t("campaign.sim_fee")))]),
                  _c("td", { staticClass: "text-right" }, [
                    _vm._v("- " + _vm._s(_vm.money(_vm.sim.fee))),
                  ]),
                ]),
                _c(
                  "tr",
                  {
                    class:
                      _vm.sim.net <= 0
                        ? "text-danger font-medium"
                        : "font-medium",
                  },
                  [
                    _c("td", [_vm._v(_vm._s(_vm.$t("campaign.sim_net")))]),
                    _c("td", { staticClass: "text-right" }, [
                      _vm._v(
                        _vm._s(_vm.money(_vm.sim.net)) +
                          " (" +
                          _vm._s(_vm.sim.netPct) +
                          "%)"
                      ),
                    ]),
                  ]
                ),
              ]),
            ]),
            _vm.sim.net <= 0
              ? _c(
                  "b-alert",
                  {
                    staticClass: "mt-2 mb-0 p-1",
                    attrs: { variant: "danger", show: "" },
                  },
                  [
                    _c("small", [
                      _vm._v(_vm._s(_vm.$t("campaign.sim_negative"))),
                    ]),
                  ]
                )
              : _vm.sim.netPct < 50
              ? _c(
                  "b-alert",
                  {
                    staticClass: "mt-2 mb-0 p-1",
                    attrs: { variant: "warning", show: "" },
                  },
                  [_c("small", [_vm._v(_vm._s(_vm.$t("campaign.sim_thin")))])]
                )
              : _vm._e(),
          ],
          1
        ),
      ]),
      _c("vx-card", { staticClass: "mb-4" }, [
        _c("h4", { staticClass: "mb-1" }, [
          _vm._v(_vm._s(_vm.$t("campaign.section_rules"))),
        ]),
        _c("div", { staticClass: "vx-row" }, [
          _c(
            "div",
            { staticClass: "vx-col sm:w-3/12 w-full" },
            [
              _c(
                "b-form-group",
                { attrs: { label: _vm.$t("campaign.attribution_window") } },
                [
                  _c("b-form-input", {
                    attrs: { type: "number", min: "1", max: "365" },
                    model: {
                      value: _vm.model.attribution_window_days,
                      callback: function ($$v) {
                        _vm.$set(_vm.model, "attribution_window_days", $$v)
                      },
                      expression: "model.attribution_window_days",
                    },
                  }),
                  _c("small", { staticClass: "text-muted" }, [
                    _vm._v(_vm._s(_vm.$t("campaign.attribution_window_hint"))),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "vx-col sm:w-3/12 w-full" },
            [
              _c(
                "b-form-group",
                { attrs: { label: _vm.$t("campaign.hold_days") } },
                [
                  _c("b-form-input", {
                    attrs: { type: "number", min: "0", max: "365" },
                    model: {
                      value: _vm.model.hold_days,
                      callback: function ($$v) {
                        _vm.$set(_vm.model, "hold_days", $$v)
                      },
                      expression: "model.hold_days",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "vx-col sm:w-3/12 w-full" },
            [
              _c(
                "b-form-group",
                { attrs: { label: _vm.$t("campaign.hold_from") } },
                [
                  _c("b-form-select", {
                    attrs: { options: _vm.holdFromList },
                    model: {
                      value: _vm.model.hold_from,
                      callback: function ($$v) {
                        _vm.$set(_vm.model, "hold_from", $$v)
                      },
                      expression: "model.hold_from",
                    },
                  }),
                  _c("small", { staticClass: "text-muted" }, [
                    _vm._v(_vm._s(_vm.$t("campaign.hold_from_hint"))),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "vx-col sm:w-3/12 w-full" },
            [
              _c(
                "b-form-group",
                {
                  attrs: { label: _vm.$t("campaign.usage_limit_per_customer") },
                },
                [
                  _c("b-form-input", {
                    attrs: { type: "number", min: "1" },
                    model: {
                      value: _vm.model.usage_limit_per_customer,
                      callback: function ($$v) {
                        _vm.$set(_vm.model, "usage_limit_per_customer", $$v)
                      },
                      expression: "model.usage_limit_per_customer",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ]),
        _c("div", { staticClass: "vx-row" }, [
          _c(
            "div",
            { staticClass: "vx-col sm:w-4/12 w-full" },
            [
              _c(
                "b-form-group",
                { attrs: { label: _vm.$t("campaign.first_purchase_only") } },
                [
                  _c("b-form-checkbox", {
                    attrs: { switch: "" },
                    model: {
                      value: _vm.model.first_purchase_only,
                      callback: function ($$v) {
                        _vm.$set(_vm.model, "first_purchase_only", $$v)
                      },
                      expression: "model.first_purchase_only",
                    },
                  }),
                  _c("small", { staticClass: "text-muted" }, [
                    _vm._v(_vm._s(_vm.$t("campaign.first_purchase_only_hint"))),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "vx-col sm:w-4/12 w-full" },
            [
              _c(
                "b-form-group",
                { attrs: { label: _vm.$t("campaign.join_mode") } },
                [
                  _c("b-form-select", {
                    attrs: { options: _vm.joinModeList },
                    model: {
                      value: _vm.model.join_mode,
                      callback: function ($$v) {
                        _vm.$set(_vm.model, "join_mode", $$v)
                      },
                      expression: "model.join_mode",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "vx-col sm:w-4/12 w-full" },
            [
              _c(
                "b-form-group",
                { attrs: { label: _vm.$t("campaign.auto_approve") } },
                [
                  _c("b-form-checkbox", {
                    attrs: { switch: "" },
                    model: {
                      value: _vm.model.auto_approve_influencers,
                      callback: function ($$v) {
                        _vm.$set(_vm.model, "auto_approve_influencers", $$v)
                      },
                      expression: "model.auto_approve_influencers",
                    },
                  }),
                  _c("small", { staticClass: "text-muted" }, [
                    _vm._v(_vm._s(_vm.$t("campaign.auto_approve_hint"))),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
        ]),
        _c("div", { staticClass: "vx-row" }, [
          _c(
            "div",
            { staticClass: "vx-col sm:w-4/12 w-full" },
            [
              _c(
                "b-form-group",
                { attrs: { label: _vm.$t("campaign.influencer_free_uses") } },
                [
                  _c("b-form-input", {
                    attrs: { type: "number", min: "0", max: "99" },
                    model: {
                      value: _vm.model.influencer_free_uses,
                      callback: function ($$v) {
                        _vm.$set(_vm.model, "influencer_free_uses", $$v)
                      },
                      expression: "model.influencer_free_uses",
                    },
                  }),
                  _c("small", { staticClass: "text-muted" }, [
                    _vm._v(
                      _vm._s(_vm.$t("campaign.influencer_free_uses_hint"))
                    ),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
        ]),
      ]),
      _c(
        "vx-card",
        { staticClass: "mb-4" },
        [
          _c("h4", { staticClass: "mb-1" }, [
            _vm._v(_vm._s(_vm.$t("campaign.section_audience"))),
          ]),
          _c("small", { staticClass: "text-muted d-block mb-2" }, [
            _vm._v(_vm._s(_vm.$t("campaign.section_audience_hint"))),
          ]),
          _c(
            "b-form-checkbox",
            {
              staticClass: "mb-2",
              attrs: { switch: "" },
              model: {
                value: _vm.audienceAll,
                callback: function ($$v) {
                  _vm.audienceAll = $$v
                },
                expression: "audienceAll",
              },
            },
            [_vm._v(" " + _vm._s(_vm.$t("campaign.audience_all")) + " ")]
          ),
          !_vm.audienceAll
            ? _c("div", { staticClass: "vx-row" }, [
                _c(
                  "div",
                  { staticClass: "vx-col sm:w-4/12 w-full" },
                  [
                    _c(
                      "b-form-group",
                      { attrs: { label: _vm.$t("campaign.audience_groups") } },
                      [
                        _c("v-select", {
                          staticClass: "w-full",
                          attrs: {
                            options: _vm.groups,
                            reduce: function (o) {
                              return o.id
                            },
                            label: "name",
                            multiple: "",
                          },
                          model: {
                            value: _vm.audienceGroups,
                            callback: function ($$v) {
                              _vm.audienceGroups = $$v
                            },
                            expression: "audienceGroups",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "vx-col sm:w-4/12 w-full" },
                  [
                    _c(
                      "b-form-group",
                      { attrs: { label: _vm.$t("campaign.audience_levels") } },
                      [
                        _c("v-select", {
                          staticClass: "w-full",
                          attrs: {
                            options: _vm.levels,
                            reduce: function (o) {
                              return o.id
                            },
                            label: "name",
                            multiple: "",
                          },
                          model: {
                            value: _vm.audienceLevels,
                            callback: function ($$v) {
                              _vm.audienceLevels = $$v
                            },
                            expression: "audienceLevels",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "vx-col sm:w-4/12 w-full" },
                  [
                    _c(
                      "b-form-group",
                      {
                        attrs: {
                          label: _vm.$t("campaign.audience_influencers"),
                        },
                      },
                      [
                        _c("v-select", {
                          staticClass: "w-full",
                          attrs: {
                            options: _vm.influencers,
                            reduce: function (o) {
                              return o.id
                            },
                            label: "name",
                            multiple: "",
                          },
                          model: {
                            value: _vm.audienceInfluencers,
                            callback: function ($$v) {
                              _vm.audienceInfluencers = $$v
                            },
                            expression: "audienceInfluencers",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ])
            : _vm._e(),
        ],
        1
      ),
      _c(
        "vx-card",
        { staticClass: "mb-4" },
        [
          _c("h4", { staticClass: "mb-1" }, [
            _vm._v(_vm._s(_vm.$t("campaign.section_briefing"))),
          ]),
          _c(
            "b-form-group",
            { attrs: { label: _vm.$t("campaign.briefing") } },
            [
              _c("b-form-textarea", {
                attrs: { rows: "3" },
                model: {
                  value: _vm.model.briefing,
                  callback: function ($$v) {
                    _vm.$set(_vm.model, "briefing", $$v)
                  },
                  expression: "model.briefing",
                },
              }),
            ],
            1
          ),
          _c("div", { staticClass: "vx-row" }, [
            _c(
              "div",
              { staticClass: "vx-col sm:w-6/12 w-full" },
              [
                _c(
                  "b-form-group",
                  { attrs: { label: _vm.$t("campaign.dos") } },
                  [
                    _c("b-form-textarea", {
                      attrs: { rows: "2" },
                      model: {
                        value: _vm.model.dos,
                        callback: function ($$v) {
                          _vm.$set(_vm.model, "dos", $$v)
                        },
                        expression: "model.dos",
                      },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "vx-col sm:w-6/12 w-full" },
              [
                _c(
                  "b-form-group",
                  { attrs: { label: _vm.$t("campaign.donts") } },
                  [
                    _c("b-form-textarea", {
                      attrs: { rows: "2" },
                      model: {
                        value: _vm.model.donts,
                        callback: function ($$v) {
                          _vm.$set(_vm.model, "donts", $$v)
                        },
                        expression: "model.donts",
                      },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
          ]),
          _c("div", { staticClass: "vx-row" }, [
            _c(
              "div",
              { staticClass: "vx-col sm:w-4/12 w-full" },
              [
                _c(
                  "b-form-group",
                  { attrs: { label: _vm.$t("campaign.hashtags") } },
                  [
                    _c("b-form-input", {
                      attrs: { type: "text", placeholder: "#treino, #hubee" },
                      model: {
                        value: _vm.hashtagsText,
                        callback: function ($$v) {
                          _vm.hashtagsText = $$v
                        },
                        expression: "hashtagsText",
                      },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "vx-col sm:w-4/12 w-full" },
              [
                _c(
                  "b-form-group",
                  { attrs: { label: _vm.$t("campaign.mentions") } },
                  [
                    _c("b-form-input", {
                      attrs: { type: "text", placeholder: "@clube" },
                      model: {
                        value: _vm.mentionsText,
                        callback: function ($$v) {
                          _vm.mentionsText = $$v
                        },
                        expression: "mentionsText",
                      },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "vx-col sm:w-4/12 w-full" },
              [
                _c(
                  "b-form-group",
                  { attrs: { label: _vm.$t("campaign.disclosure_tag") } },
                  [
                    _c("b-form-input", {
                      attrs: { type: "text" },
                      model: {
                        value: _vm.model.disclosure_tag,
                        callback: function ($$v) {
                          _vm.$set(_vm.model, "disclosure_tag", $$v)
                        },
                        expression: "model.disclosure_tag",
                      },
                    }),
                    _c("small", { staticClass: "text-muted" }, [
                      _vm._v(_vm._s(_vm.$t("campaign.disclosure_tag_hint"))),
                    ]),
                  ],
                  1
                ),
              ],
              1
            ),
          ]),
          _c(
            "b-form-group",
            { attrs: { label: _vm.$t("campaign.rules") } },
            [
              _c("b-form-textarea", {
                attrs: { rows: "3" },
                model: {
                  value: _vm.model.rules,
                  callback: function ($$v) {
                    _vm.$set(_vm.model, "rules", $$v)
                  },
                  expression: "model.rules",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "b-form-row",
        { staticClass: "justify-end mt-2" },
        [
          _c(
            "b-col",
            { attrs: { cols: "auto" } },
            [
              _c(
                "b-button",
                { attrs: { variant: "primary" }, on: { click: _vm.save } },
                [_vm._v(_vm._s(_vm.$t("save")))]
              ),
            ],
            1
          ),
          _vm.isEdit && _vm.model.status === "DR"
            ? _c(
                "b-col",
                { attrs: { cols: "auto" } },
                [
                  _c(
                    "b-button",
                    {
                      directives: [
                        {
                          name: "permission",
                          rawName: "v-permission",
                          value: "campaigns.edit",
                          expression: "'campaigns.edit'",
                        },
                      ],
                      attrs: { variant: "success" },
                      on: { click: _vm.publish },
                    },
                    [_vm._v(" " + _vm._s(_vm.$t("campaign.publish")) + " ")]
                  ),
                ],
                1
              )
            : _vm._e(),
          _c(
            "b-col",
            { attrs: { cols: "auto" } },
            [
              _c(
                "b-button",
                {
                  attrs: { variant: "outline-secondary" },
                  on: { click: _vm.goBack },
                },
                [
                  _c("feather-icon", {
                    staticClass: "mr-50",
                    attrs: { icon: "CornerUpLeftIcon" },
                  }),
                  _c("span", { staticClass: "align-middle" }, [
                    _vm._v(_vm._s(_vm.$t("back"))),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }